import {
  READ_ACTION,
  INVESTMENT_FUNDS_MENU,
  FIXED_INCOME_DAILY_OFFERS_MENU,
} from "@/constants/resources";

export default [
  {
    title: "Investimentos",
    icon: "none",
    children: [
      {
        title: "Fundos de Investimentos",
        route: "investment-funds",
        icon: "LineChartIcon",
        resource: INVESTMENT_FUNDS_MENU,
        action: READ_ACTION,
      },
      {
        title: "Ofertas Diárias de Renda Fixa",
        route: "fixed-income-daily-offers",
        icon: "BanknoteIcon",
        resource: FIXED_INCOME_DAILY_OFFERS_MENU,
        action: READ_ACTION,
      },
    ],
  }
]
